
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Container } from "../../components/util/container";
import { Section } from "../../components/util/section";
import Posts from "../../components/blog/BlogPosts";
import Header from "../../components/blog/Header";
import { client } from "../../../tina/__generated__/client";
export default function News(props: any) {
    return (<Section className="flex-1">
      <Header>
        <h2 className="relative w-full text-3xl font-extrabold tracking-normal text-center text-gray-100 md:text-5xl title-font">
          Chess News
        </h2>
        <div className="max-w-2xl mx-auto mt-4 text-sm font-normal text-center text-gray-300 md:text-base">
          See what&apos;s happening at Chess Hotel and in our chess community.
        </div>
      </Header>
      <Container size="medium" width="small">
        <div className="pt-10 pb-12">
          <Posts data={props.posts} mode="news"/>
        </div>
      </Container>
    </Section>);
}
const getStaticProps = async () => {
    const postsResponse = await client.queries.postConnection({
        filter: { locale: { eq: "en" } },
    });
    const posts = postsResponse.data.postConnection.edges.filter((edge) => {
        const post = edge?.node;
        const categorySlug = post?.category?.slug;
        const folderCategory = post?._sys?.breadcrumbs?.[0];
        return categorySlug === "news" || folderCategory === "news";
    });
    return {
        props: {
            posts,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a042aa3d7c__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3d7c__ as getStaticProps }
  